/**
 * Extend core modal JS
 **/
define([
    'jquery'
],
($) => {
    return function (widget) {
        $.widget('mage.modal', widget, {
            /**
             * Close modal.
             * @return {Element} - current element.
             */
            closeModal: function () {
                this._removeKeyListener();
                this.options.isOpen = false;
                this.modal.one(this.options.transitionEvent, () => {
                    this._close();
                });
                this.modal.removeClass(this.options.modalVisibleClass);

                if (!this.options.transitionEvent) {
                    this._close();
                }
                // fix the issue when there is no transition property added to
                // element, the overlay can't be destroyed properly, which causes
                // the second time modal is opened, a proper overlay can't be
                // created
                this._close();

                return this.element;
            },
            /**
             * Destroy overlay.
             */
            _destroyOverlay: function () {
                if (this._getVisibleCount()) {
                    this.overlay.unbind().on('click', this.prevOverlayHandler);
                } else {
                    $(this.options.appendTo).removeClass(this.options.parentModalClass);
                    if (this.overlay) {
                        this.overlay.remove();
                    }
                    this.overlay = null;
                }
            }
        });

        return $.mage.modal;
    };
});
